import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {SzButton, SzIcon, SzList, SzTypographie} from "@suezenv/react-theme-components";
import {MAX_CHAR_ALARM_COMMENT} from "../../store/constants";
import {TextArea} from "../../../main/components/Utils/textArea";

const AlarmCommentAdd: any = (props: any) => {
    const {t} = useTranslation();
    const {commentSubmitHandler, alarm, closeHandle} = props;
    const [comment, setComment] = useState(alarm?.comment ? alarm.comment : "");
    
    return (
        <>
            <SzList>
                <SzList.Item>
                    < div className="row">
                        <div className="col-2">
                            <SzIcon variant="line" icon="common-file-text"/>
                        </div>
                        <div className="col-10">
                            <SzTypographie>{t("alarm:comment_add")}</SzTypographie>
                        </div>
                    </div>
                </SzList.Item>
            </SzList>
            <div className="row m-0 p-0 mb-5">
                <div className="col-2 pt-2">
                    <SzTypographie>{t("alarm:comment_label")}</SzTypographie>
                </div>
                <div className="col-10">
                    <TextArea
                        className="mb-1 ack-comment"
                        placeholder={t("alarm:max_char",{length:MAX_CHAR_ALARM_COMMENT})}
                        onChange={(e:any)=>{
                            if(e.target.value.length <= MAX_CHAR_ALARM_COMMENT) {
                                setComment(e.target.value)
                            }
                        }}
                        name="comment"
                        value={comment}
                        rows={4}
                    />
                </div>
            </div>
            <div className="text-center mt-5 mb-4">
                <SzButton 
                    onClick={() => {
                        commentSubmitHandler(alarm, comment);
                        closeHandle();
                    }}
                    className="mr-3">{t("alarm:btn.validate")}
                </SzButton>
            </div>
        </>
    );
};

export default AlarmCommentAdd;
